const requestMarkdownActions = {
  CLOSE_REQUEST_MARKDOWN: 'CLOSE_REQUEST_MARKDOWN',
  DESTROY_REQUESTS_MARKDOWN: 'DESTROY_REQUESTS_MARKDOWN',
  DOWNLOAD_REQUEST_MARKDOWN: 'DOWNLOAD_REQUEST_MARKDOWN',
  DOWNLOAD_REQUEST_MARKDOWN_ERROR: 'DOWNLOAD_REQUEST_MARKDOWN_ERROR',
  FETCH_REQUEST_MARKDOWN: 'FETCH_REQUEST_MARKDOWN',
  FETCH_REQUEST_MARKDOWN_ERROR: 'FETCH_REQUEST_MARKDOWN_ERROR',
  FETCH_REQUEST_MARKDOWN_SUCCESS: 'FETCH_REQUEST_MARKDOWN_SUCCESS',
};

export const requestMarkdownCategories = ['open'];

export default requestMarkdownActions;
